import React, { useState } from "react";
import { useEffect } from "react";
import { useAlert } from "react-alert";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import api from "../../api";
import { ConsentTerms } from "./consentTerms";
import userAction from "../../redux/users/action";
import "./beforePayTermsModal.css";

const FIELDS = [
  "confirmAccount",
  "authCard",
  "monthlysubs",
  "renewAuto",
  "nonRefund",
  "aggreeTerms",
  "understandMisuse",
  "unauthTransaction",
];

export const BeforePayTerms = ({
  show,
  handleShow,
  handleClose,
  onStripePay,
}) => {
  const userStore = useSelector((state) => state.userReducer);
  const alert = useAlert();
  const [data, setData] = useState({});
  const [loader, setLoader] = useState(false);

  const accept = async () => {
    try {
      const validatorsResponse = validators();

      if (validatorsResponse) {
        return alert.show(validatorsResponse);
      }
      setLoader(true);
      const payload = {
        confirmAccount: data.confirmAccount,
        authCard: data.authCard,
        monthlySubscription: data.monthlysubs,
        renewAuto: data.renewAuto,
        nonRefund: data.nonRefund,
        aggreeTerms: data.aggreeTerms,
        understandMisuse: data.understandMisuse,
        unauthTransaction: data.unauthTransaction,
      };

      const response = await api.addSubscriptionConsents(payload);
      // console.log(response);
      if (response?.consent) {
        onStripePay();
        handleClose();
        setLoader(false);
      }
    } catch (error) {
      console.log(error?.message);
      alert.show("Something went wrong");
    }
  };

  const validators = () => {
    if (!data?.confirmAccount) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.authCard) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.monthlysubs) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.renewAuto) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.nonRefund) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.aggreeTerms) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.understandMisuse) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.unauthTransaction) {
      return "Kindly confirm each checkbox to proceed.";
    }
    return false;
  };

  const toggleField = (name) => (e) => {
    if (e.target.tagName === "A") return;
    setData((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const doneCount = FIELDS.filter((f) => data[f]).length;
  const totalCount = FIELDS.length;
  const allDone = doneCount === totalCount;
  const progressPct = Math.round((doneCount / totalCount) * 100);

  return (
    <Modal
      size="lg"
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="bpt-dialog"
      contentClassName="bpt-content"
    >
      <div className="bpt-modal">
        <div className="bpt-head">
          <div className="bpt-blob b1"></div>
          <div className="bpt-blob b2"></div>
          <button
            type="button"
            className="bpt-close"
            aria-label="Close"
            onClick={handleClose}
          >
            <i className="fa-solid fa-xmark" />
          </button>
          <div className="bpt-head-inner">
            <div className="bpt-pill">&#128274; Secure Checkout</div>
            <h2 className="bpt-title">
              Before You Subscribe, Please Confirm the Following
            </h2>
            <div className="bpt-progress-wrap">
              <div className="bpt-progress-meta">
                <span>
                  {allDone
                    ? "All confirmations complete"
                    : `${doneCount} of ${totalCount} confirmed`}
                </span>
                <span>{progressPct}%</span>
              </div>
              <div className="bpt-track">
                <div
                  className={`bpt-fill${allDone ? " complete" : ""}`}
                  style={{ width: `${progressPct}%` }}
                ></div>
              </div>
            </div>
          </div>
        </div>

        <div className="bpt-body">
          <div className="bpt-list">
            <div
              className={`bpt-row${data.confirmAccount ? " is-checked" : ""}`}
              onClick={toggleField("confirmAccount")}
            >
              <div className="bpt-box">
                <span className="num">1</span>
                <span className="tick">&#10003;</span>
              </div>
              <span className="bpt-text">
                I confirm that I am the owner of this account.
              </span>
            </div>

            <div
              className={`bpt-row${data.authCard ? " is-checked" : ""}`}
              onClick={toggleField("authCard")}
            >
              <div className="bpt-box">
                <span className="num">2</span>
                <span className="tick">&#10003;</span>
              </div>
              <span className="bpt-text">
                I confirm that I am using my own credit/debit card or have
                authorized access to this card.
              </span>
            </div>

            <div
              className={`bpt-row${data.monthlysubs ? " is-checked" : ""}`}
              onClick={toggleField("monthlysubs")}
            >
              <div className="bpt-box">
                <span className="num">3</span>
                <span className="tick">&#10003;</span>
              </div>
              <span className="bpt-text">
                I authorize WaqarZaka.net to charge my card for a monthly
                subscription.
              </span>
            </div>

            <div
              className={`bpt-row${data.renewAuto ? " is-checked" : ""}`}
              onClick={toggleField("renewAuto")}
            >
              <div className="bpt-box">
                <span className="num">4</span>
                <span className="tick">&#10003;</span>
              </div>
              <span className="bpt-text">
                I understand that after my first month’s payment, my
                subscription will automatically renew each month unless I
                cancel it in advance.
              </span>
            </div>

            <div
              className={`bpt-row${data.nonRefund ? " is-checked" : ""}`}
              onClick={toggleField("nonRefund")}
            >
              <div className="bpt-box">
                <span className="num">5</span>
                <span className="tick">&#10003;</span>
              </div>
              <span className="bpt-text">
                I understand this is a non-refundable digital subscription,
                and after 12 hours of purchase, no refund requests will be
                accepted.
              </span>
            </div>

            <div
              className={`bpt-row${data.aggreeTerms ? " is-checked" : ""}`}
              onClick={toggleField("aggreeTerms")}
            >
              <div className="bpt-box">
                <span className="num">6</span>
                <span className="tick">&#10003;</span>
              </div>
              <span className="bpt-text">
                I agree to the platform’s{" "}
                <Link to="/terms-and-conditions">Terms & Conditions</Link> and{" "}
                <Link to="/privacy-policy">Privacy Policy.</Link>
              </span>
            </div>

            <div
              className={`bpt-row${data.understandMisuse ? " is-checked" : ""}`}
              onClick={toggleField("understandMisuse")}
            >
              <div className="bpt-box">
                <span className="num">7</span>
                <span className="tick">&#10003;</span>
              </div>
              <span className="bpt-text">
                I understand that misuse, account sharing, or reselling
                content may lead to account suspension without refund.
              </span>
            </div>

            <div
              className={`bpt-row${data.unauthTransaction ? " is-checked" : ""}`}
              onClick={toggleField("unauthTransaction")}
            >
              <div className="bpt-box">
                <span className="num">8</span>
                <span className="tick">&#10003;</span>
              </div>
              <span className="bpt-text">
                I agree that any unauthorized or fraudulent activity may lead
                to data disclosure, account suspension, and legal action.{" "}
                <Link to={"/unauthorized-transaction"}>For more info</Link>
              </span>
            </div>
          </div>
        </div>

        <div className="bpt-foot">
          <button type="button" className="bpt-cancel" onClick={handleClose}>
            Cancel
          </button>
          <button
            type="button"
            className={`bpt-cta${allDone ? " ready" : ""}`}
            disabled={!allDone}
            onClick={accept}
          >
            <span className="bpt-shine"></span>
            <span className="label">
              {allDone ? "Accept & Continue" : `Confirm all ${totalCount} items`}
            </span>
          </button>
        </div>
      </div>
    </Modal>
  );
};
